import { z } from 'zod';
import { DisplayModeSchema } from '../config/index.ts';

export const FrameQuerySchema = z.object({
  pk: z.string().regex(/^plato_pk_(?:test|live)_[0-9A-Za-z_]{1,128}$/),
  mode: DisplayModeSchema.optional(),
  preview: z.literal('1').optional(),
});
export type FrameQuery = z.infer<typeof FrameQuerySchema>;
